import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Facebook from "../../atoms/icons/social-share/facebook";
import Twitter from "../../atoms/icons/social-share/twitter";
import Whatsapp from "../../atoms/icons/social-share/whatsapp";
import Telegram from "../../atoms/icons/social-share/telegram";
import Youtube from "../../atoms/icons/social-share/youtube";

import "./social-icons.m.css";

const SocialIcons = ({ socialLinks, telegramUrl }) => {
  if (!socialLinks) {
    return null;
  }

  const list = [
    {
      Type: <Facebook isShareRequired={false} />,
      url: socialLinks["facebook-url"] || "",
    },
    {
      Type: <Twitter isShareRequired={false} />,
      url: socialLinks["twitter-url"] || "",
    },
    {
      Type: <Whatsapp isShareRequired={false} />,
      url: socialLinks["whatsapp-url"] || "",
    },
    {
      Type: <Telegram isShareRequired={false} />,
      url: socialLinks["telegram-url"] || telegramUrl,
    },
    {
      Type: <Youtube isShareRequired={false} />,
      url: socialLinks["youtube-url"] || "",
    },
  ];

  return (
    <div styleName="wrapper">
      {list.map(({ url, Type }, index) => (
        <a
          href={url}
          key={index}
          styleName="social-link-item"
          className="social-link-item"
          target="_blank"
          rel="nofollow"
        >
          {Type}
        </a>
      ))}
    </div>
  );
};

SocialIcons.propTypes = {
  socialLinks: object,
  telegramUrl: string,
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], null),
  telegramUrl: get(state, ["qt", "config", "publisher-attributes", "social_links", "telegram_Url"], ""),
});

export default connect(mapStateToProps, null)(SocialIcons);
